<template>
  <div>
    <v-container>
      <v-card>
        <v-card-title>
          <v-row  v-if="!vedorManagable">
            <v-alert
             
              border="top"
              color="red lighten-2"
              dark
              dismissible
              dense
            >
              کاربر گرامی، کسب و کار شما جهت مدیریت وندور لیست فعال نشده است، در
              صورت نیاز با واحد پشتیبانی تکصان تماس بگیرید
            </v-alert>
          </v-row>
          <v-row>
            <v-btn color="primary" class="mx-1 float-left"   @click.stop="openVendorList()">وندورها</v-btn>
            <v-divider></v-divider>
            <v-btn
              class="mx-1 float-left"
              color="primary"
              @click.stop="openCreateOrEditVendorDialog()"
            >
              تعریف گروه‌های وندورها</v-btn
            >
            <v-divider></v-divider>
            <v-btn
              class="mx-1 float-left"
              color="primary"
              @click.stop="openCreateOrEditDialog()"
            >
              وندور جدید</v-btn
            >
          </v-row>
        </v-card-title>
        <v-divider> </v-divider>
        <v-card-text>
          <vendors-list
            v-if="
              !vendorGroupFormIsOpen &&
              !$store.getters.vendorsFormStatus &&
              !$store.getters.vendorsGroupFormStatus
            "
          >
          </vendors-list>
        </v-card-text>
      </v-card>
      <vendors-form v-if="$store.getters.vendorsFormStatus"> </vendors-form>
      <vendors-group-form v-if="$store.getters.vendorsGroupFormStatus">
      </vendors-group-form>
    </v-container>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const merchantRepository = () => RepoFactory.get('merchant');
import VendorsForm from '../components/VendorsForm.vue';
import VendorsGroupForm from '../components/VendorsGroupForm.vue';
import VendorsList from '../components/VendorsList.vue';
import Helper from '@/core/helpers';

export default {
  components: {
    VendorsForm,
    VendorsList,
    VendorsGroupForm,
  },
  data() {
    return {
      vendorGroupFormIsOpen: false,
    };
  },
  computed: {
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    vedorManagable() {
      return this.$store.getters.currentMerchantObject?.vendorManageable;
    },
  },
  methods: {
    getVendorPermission(permissionId) {
      const loader = this.$loading.show();
      merchantRepository()
        .getVendorPermission(permissionId, this.merchantBaseUrl)
        .then((res) => {
          this.$store.commit('setVendorPermissionId', res.data.id);
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => loader.hide());
    },
    openCreateOrEditDialog() {
      this.$store.commit('setVendorsFormStatus', true);
      this.$store.commit('setVendorsGroupFormStatus', false);
      
    },
    openCreateOrEditVendorDialog() {
      this.$store.commit('setVendorsGroupFormStatus', true);
      this.$store.commit('setVendorsFormStatus', false);
    },
    openVendorList() {
           this.$store.commit('setVendorsGroupFormStatus', false);
      this.$store.commit('setVendorsFormStatus', false); 
    }
  },
};
</script>

<style lang="scss" scoped></style>
